const DOTS = [
  [1, 0, 1, 0, 1],
  [1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1],
  [0, 1, 1, 1, 0],
  [0, 0, 1, 0, 0],
];

export default function PixelMark({ className = "h-5 w-5" }) {
  const unit = 100 / DOTS.length;
  return (
    <svg
      viewBox="0 0 100 100"
      className={className}
      fill="currentColor"
      aria-hidden="true"
    >
      {DOTS.map((row, r) =>
        row.map((on, c) =>
          on ? (
            <circle key={`${r}-${c}`} cx={c * unit + unit / 2} cy={r * unit + unit / 2} r={unit * 0.36} />
          ) : null
        )
      )}
    </svg>
  );
}
